import React from "react";
import Link from "next/link";
import { siteVersion } from "@/lib/version";


export const Footer: React.FC = () => {
  return (
    <footer className="bg-background border-t border-border mt-auto transition-colors duration-300">
      <div className="layout-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Logo & Manifesto */}
          <div className="md:col-span-2 space-y-4">
            <span className="text-sm font-bold uppercase tracking-[0.25em] text-foreground">
              Axiom Manifold
            </span>
            <p className="text-xs text-foreground/60 max-w-sm leading-relaxed italic">
              "There is no scarcity. Only creation. This is a space where the soul is free to experience the material world."
            </p>
            <p className="text-[10px] text-foreground/40 font-mono">
              EC2-Hosted | S3 CDN Powered | Axiom Manifold © {new Date().getFullYear()}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-foreground mb-4">Categories</h3>
            <ul className="space-y-2 text-xs uppercase tracking-wider text-foreground/70">
              <li>
                <Link href="/catalog?collection=Rare" className="hover:text-primary transition hover:underline underline-offset-4">
                  Rare
                </Link>
              </li>
              <li>
                <Link href="/catalog?collection=New" className="hover:text-primary transition hover:underline underline-offset-4">
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link href="/catalog?collection=Partial" className="hover:text-primary transition hover:underline underline-offset-4">
                  Partials
                </Link>
              </li>
              <li>
                <Link href="/catalog?collection=Samples" className="hover:text-primary transition hover:underline underline-offset-4">
                  Samples & Decants
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Care */}
          <div>
            <h3 className="text-xs font-bold uppercase tracking-widest text-foreground mb-4">Inquiries</h3>
            <ul className="space-y-2 text-xs uppercase tracking-wider text-foreground/70">
              <li>
                <Link href="/profile" className="hover:text-primary transition hover:underline underline-offset-4">
                  My Account
                </Link>
              </li>
              <li>
                <Link href="/contact" className="hover:text-primary transition hover:underline underline-offset-4">
                  Write to Us
                </Link>
              </li>
              <li>
                <Link href="/contact" className="hover:text-primary transition hover:underline underline-offset-4">
                  <span className="text-foreground/50">AWS Cloud Architecture by Synaptic Geometry</span>
                </Link>
              </li>
              <li>
                <span className="text-foreground/50">Version: {siteVersion.major}.{siteVersion.minor}.{siteVersion.revision}</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </footer>
  );
};
export default Footer;
